export enum SubjectFields {
    NAME = 'name',
    COLOR = 'color',
    TOPICS = 'topics',
    HIDDEN_FROM_SELECTION = 'hiddenFromSelection',
}
